function getJSONValue(stringValue) {
	try {
		return JSON.parse(stringValue);
	} catch (error) {
		return stringValue;
	}
}

function camelCase(string) {
    return string.replace(/^([A-Z])|[\s-_](\w)/g, function(match, p1, p2) {
        if (p2) {
            return p2.toUpperCase();
        }

        return p1.toLowerCase();
    });
  }

function getOptionData(element) {
	const dataset = element.dataset;
	const data = {};

	for (const prop in dataset) {
		if (dataset.hasOwnProperty(prop)) {
			data[prop] = dataset[prop];
		}
	}
	return data || {};
}

function extractComponentOptions(name, data) {
	const options = {};
	const cameledName = camelCase(name);
	for (const prop in data) {
		if (prop.startsWith(cameledName) && prop !== cameledName) {
			options[camelCase(prop.slice(cameledName.length))] =
				getJSONValue(data[prop]);
		}
	}
	return options;
}

export default function(name, element) {
	return extractComponentOptions(name, getOptionData(element));
}



// WEBPACK FOOTER //
// ./client/src/core/lib/extract-options.js